<template>
	<transition name="modal">
		<div class="modal-mask" :class="`modal-type-${type}`">
			<div class="modal-wrapper has-scroll custom">
				<div class="modal-container custom" :class="`modal-container-${size}`">
					<div class="modal-header-custom">
						<i
							class="modal-close material-icons custom-icon-close"
							@click="$emit('close')"
							v-if="showClose"
						>
							close
						</i>
						<button
							type="button"
							class="close hidden"
							aria-label="Close"
							@click="$emit('close')"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body-custom">
						<slot name="body"></slot>
					</div>

					<div class="modal-footer" v-if="!hideFooter">
						<slot name="footer">
							<button class="btn btn-primary" @click="$emit('close')">OK</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: {
		size: {
			type: String,
			default: 'small',
		},
		showClose: {
			type: Boolean,
			default: true,
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
		full: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'popup', // popup, lightbox
		},
	},
	methods: {
		onKeyup(event) {
			if (event.key === 'Escape') {
				this.$emit('close');
			}
		},
	},
	created() {
		document.body.classList.add('modal-open');
		window.addEventListener('keyup', this.onKeyup);
	},
	destroyed() {
		document.body.classList.remove('modal-open');
		window.removeEventListener('keyup', this.onKeyup);
	},
};
</script>

<style scoped lang="scss">
.modal-header-custom {
	display: flex;
	background-color: transparent;
	flex-direction: row-reverse;
	padding: 12px 10px;
}

.modal-container.custom {
	background-color: transparent;
}

.modal-wrapper.custom {
	padding-left: 0;
	padding-right: 0;
}

.custom-icon-close {
	color: #ffffff;
}
</style>
